import React from 'react';
import '../styles/Navbar.css';

const Navbar = () => {
    return (
        <nav className="navbar">
            <h1>Movie List App</h1>
        </nav>
    );
};

export default Navbar;